module.exports = __webpack_public_path__ + "static/media/frozen.83761e86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/frozen.png
// module id = 99
// module chunks = 0